import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";

export function getNotificationCategoryLabel(category: string) {
  if (category === "MARKETING") {
    return "Encamp";
  }

  return prettyPrintEnumValue(category);
}

export function getNotificationProgramAreaLabel(programArea: string) {
  if (programArea === "EPCRA") {
    return "Chemicals";
  }

  if (programArea === "RCRA") {
    return "Waste";
  }

  return prettyPrintEnumValue(programArea);
}

export function getNotificationPriorityLabel(priority: string) {
  return `${prettyPrintEnumValue(priority)} priority`;
}
